import { Component } from 'vue-property-decorator';
import EditorBase from './EditorBase';
import { Tabs } from 'streamlabs-beaker';
import { EPlatformNames, EPlatformReadableNames } from '@/helpers/platforms';
import TwitchStreamContainer from './TwitchStreamContainer.vue';
import YoutubeStreamContainer from './YoutubeStreamContainer.vue';
import KickStreamContainer from './KickStreamContainer.vue';
import { ITab } from '@/helpers/utils';

@Component({
  components: {
    YoutubeStreamContainer,
    TwitchStreamContainer,
    KickStreamContainer,
    STabs: Tabs,
  }
})
export default class StreamContainer extends EditorBase {
  selectedTab = EPlatformNames.twitch;

  get tabs(): ITab[] {
    let tabs = [];

    if (this.isTwitchLive) {
      tabs.push({
        name: EPlatformReadableNames.twitch,
        value: EPlatformNames.twitch,
      });
    }

    if (this.isYoutubeLive) {
      tabs.push({
        name: EPlatformReadableNames.youtube,
        value: EPlatformNames.youtube,
      });
    }

    if (this.isKickLive) {
      tabs.push({
        name: EPlatformReadableNames.kick,
        value: EPlatformNames.kick,
      });
    }

    return tabs;
  }

  get channelName(): string {
    return this.userTwitchAccount.name;
  }

  get origin(): string {
    return window.location.hostname;
  }

  get isTwitchLive(): boolean {
    return !!this.userModule.livePlatforms.includes(EPlatformNames.twitch);
  }

  get isYoutubeLive(): boolean {
    return !!this.userModule.livePlatforms.includes(EPlatformNames.youtube);
  }

  get isKickLive(): boolean {
    return !!this.userModule.livePlatforms.includes(EPlatformNames.kick);
  }

  get isTiktokLive(): boolean {
    return !!this.userModule.livePlatforms.includes(EPlatformNames.tiktok);
  }

  get multiplePlatformsLive(): boolean {
    return this.userModule.livePlatforms.length > 1;
  }

  get platformNames() {
    return EPlatformNames;
  }
}
